import { createSlice } from "@reduxjs/toolkit";
import {
  addCountry,
  deleteCountry,
  editCountry,
  getCountry,
  getCountryList,
} from "../services/country-services";

const initialState = {
  countries: [],
  country: null,
  pagination: null,
  error: [],
  loading: false,
  responseMessage: null,
  success: false,
  successMessage: null,
  deleteResponse: false,
  errorMessage: null,
};

export const countrySlice = createSlice({
  name: "country",
  initialState,
  reducers: {
    resetError(state) {
      state.errorMessage = null;
    },

    resetSuccess(state) {
      state.successMessage = null;
    },

    resetState(state) {
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCountryList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getCountryList.fulfilled, (state, action) => {
        state.countries = action.payload.data.items;
        state.pagination = action.payload.data.item;
        state.currentPage = action.payload.data.item;
        state.loading = false;
      })
      .addCase(getCountryList.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getCountry.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getCountry.fulfilled, (state, action) => {
        state.countries = action.payload.data.item;
        state.pagination = action.payload.data.item;
        state.loading = false;
      })
      .addCase(getCountry.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(addCountry.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(addCountry.fulfilled, (state, action) => {
        state.countries = action.payload;
        state.successMessage = action.payload.message;
        state.loading = false;
        state.success = true;
      })
      .addCase(addCountry.rejected, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.errorMessage = action.payload;
        } else {
          state.errorMessage = "Something went wrong";
        }
      })
      .addCase(editCountry.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(editCountry.fulfilled, (state, action) => {
        state.countries = action.payload;
        state.successMessage = action.payload.message;
        state.loading = false;
        state.success = true;
      })
      .addCase(editCountry.rejected, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.errorMessage = action.payload;
        } else {
          state.errorMessage = "Something went wrong";
        }
      })
      .addCase(deleteCountry.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(deleteCountry.fulfilled, (state, action) => {
        state.countries = action.payload;
        state.responseMessage = action.payload;
        state.deleteResponse = true;
        state.successMessage = action.payload.message;
        state.loading = false;
        state.success = true;
      })
      .addCase(deleteCountry.rejected, (state, action) => {
        state.loading = false;
      });
  },
});
export const { resetSuccess, resetState,resetError } = countrySlice.actions;
export const error = (state) => state.error;
export const loading = (state) => state.loading;
export const deleteResponse = (state) => state.deleteResponse;
export default countrySlice.reducer;
